<template>
  <div
    class="w-full"
    :class="{ 'overflow-y-auto': scrollable }"
    :style="{ height: height }"
  >
    <slot></slot>
    <div v-if="loading" class="">
      <global-skeleton
        v-for="index in loadingList"
        :loadingType="loadingType"
        :key="index"
      ></global-skeleton>
    </div>
    <!-- error -->
    <div v-else-if="error">
      <div class="w-full flex flex-col items-center mt-10 p-10">
        <img
          src="/images/icons/error.png"
          class="w-2/3 mb-10"
          alt=""
          srcset=""
        />
        <div class="flex flex-col items-center">
          <div class="font-bold text-danger text-3xl">
            Opps! Terjadi Kesalahan!
          </div>
          <div class="font-base text-red-lighter  text-3xl">
            Silakan coba lagi atau hubungi Tim IT
          </div>
        </div>
      </div>
    </div>
    <!-- empty -->
    <div v-else-if="empty">
      <div class="w-full flex flex-col items-center mt-10 p-10">
        <img
          src="/images/icons/empty.png"
          class="w-2/3 mb-10"
          alt=""
          srcset=""
        />
        <div class="flex flex-col">
          <div class="font-bold  text-3xl">Tidak ada data !</div>
        </div>
      </div>
    </div>

    <div class="w-full text-center p-3" v-if="btnShowMore">
      <vs-button @click="showMore" type="border">Lihat Lagi</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingList: {
      type: Number,
      default: 1
    },
    loadingType: {
      type: String,
      default: "avatar-two-line"
    },
    scrollable: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: "auto"
    },
    empty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    btnShowMore: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    showMore() {
      this.$emit("callbackShowMore");
    }
  }
};
</script>
